import { ICheckboxFieldProps } from './BaseInputField/BaseInputField.types';
import CheckboxField from './InputTypes/CheckboxField';

const TermsConditionsAgreementInput = (props: ICheckboxFieldProps) => {
    return (
        <CheckboxField
            {...props}
            required
            name='TermsConditionsAgreement'
            dataTestid='terms-checkbox'
            label={
                <span>
                    I have read and agreed to the{' '}
                    <a href='/terms-and-conditions' target='_blank'>
                        Terms & Conditions
                    </a>
                </span>
            }
        />
    );
};

export default TermsConditionsAgreementInput;
